import { AccessToken, LoginCredentials, UserProfile } from '@models';
import { createAction, props } from '@ngrx/store';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  LoginFail = '[Auth] Login Fail',
  LoginSuccess = '[Auth] Login Success',

  FetchProfile = '[Auth] Fetch Profile',
  FetchProfileFail = '[Auth] Fetch Profile Fail',
  FetchProfileSuccess = '[Auth] Fetch Profile Success',

  Logout = '[Auth] Logout',
  Initialize = '[Auth] Initialize',
}

export const login = createAction(AuthActionTypes.Login, props<{ credentials: LoginCredentials }>());
export const loginFail = createAction(AuthActionTypes.LoginFail);
export const loginSuccess = createAction(AuthActionTypes.LoginSuccess, props<{ token: AccessToken }>());

export const fetchProfile = createAction(AuthActionTypes.FetchProfile);
export const fetchProfileFail = createAction(AuthActionTypes.FetchProfileFail);
export const fetchProfileSuccess = createAction(AuthActionTypes.FetchProfileSuccess, props<{ profile: UserProfile }>());

export const initialize = createAction(AuthActionTypes.Initialize);

export const logout = createAction(AuthActionTypes.Logout);
